import React from "react";
import { Check, ChevronRight, Loader } from "lucide-react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  isSuccess?: boolean;
  children: React.ReactNode;
}

export function Button({
  isLoading,
  isSuccess,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      className={`w-full py-2 px-4 rounded-lg text-white font-medium transition-all duration-200 
        flex items-center justify-center
        ${
          isSuccess
            ? "bg-green-500 hover:bg-green-600"
            : "bg-green-600 hover:bg-green-700"
        }
        disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      {isLoading ? (
        <Loader className="w-5 h-5 animate-spin" />
      ) : isSuccess ? (
        <>
          <Check className="w-5 h-5 mr-2" />
          Success!
        </>
      ) : (
        <>
          {children}
          <ChevronRight className="w-5 h-5 ml-2" />
        </>
      )}
    </button>
  );
}
